import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "startable",
  "use": "startable-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 13\" id=\"startable\"><path d=\"M0 6.5C0 10.091 2.905 13 6.497 13A6.501 6.501 0 100 6.5zm1.3 0c0-2.873 2.327-5.2 5.2-5.2s5.2 2.327 5.2 5.2-2.327 5.2-5.2 5.2a5.199 5.199 0 01-5.2-5.2zm2.748.809a.808.808 0 01-.81-.809c0-.448.362-.809.81-.809h4.89c.448 0 .809.361.809.809a.795.795 0 01-.795.809H4.048z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol